import React, { useEffect, useState, useContext } from "react";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import "react-phone-input-2/lib/style.css";
import Button from "react-bootstrap/Button";
import PlaceholderImg from "../../images/placeholder.png";
import EditIcon from "../../images/edit.svg";
import SuccessIcon from "../../images/success.svg";
import Modal from "react-bootstrap/Modal";
import TherapistSidebar from "../../inc/TherapistSidebar";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import { FaAlignLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ValidationsService } from "../../../utility/services/ValidationsService";
import Calendar from "react-calendar";
import Functions from "../../../utility/services/Functions";
import { toast } from "react-toastify";
import { AuthContext } from "../../../utility/services/AuthContext";
import ConstConfig from "../../../utility/configs/constConfig";
import ApiService from "../../../utility/services/ApiService";
import Select from "react-dropdown-select";
import Otp_model from "../../common/components/Otp_model";
import heic2any from "heic2any";

const PatientRegistrationAndEditProfile = () => {
  // LOGICAL VARIABLES

  const errorStyle = {
    position: "relative",
    top: -10,
  };

  const {
    consoleService,
    formetDate,
    calculateAge,
    set_patient_user_details,
    logOut,
    split_simple_year_date_month_from_str,
    localDateFromString,
    formatYMD,
    get_simple_year_date_month_str,
  } = Functions();
  const { get_states, update_patient_profile, deactivate_account } =
    ApiService();
  const { setLoading, user } = useContext(AuthContext);
  const userDetails = user.details;

  const [modalShow, setModalShow] = React.useState(false);
  const [validationsRes, setValidationsRes] = useState({});
  const [showDateModel, setShowDateModel] = useState(false);
  const [statesList, setStatesList] = useState([]);
  const [imgPreview, setImgPreview] = useState(
    userDetails.profile_img
      ? `${ConstConfig.IMAGE_URL}/${userDetails.profile_img}`
      : ""
  );
  const [submit, setSubmit] = useState(false);
  const [showDelConfirmationModal, setShowDelConfirmationModal] =
    useState(false);

  // DATA VARIABLES
  const [profile_img, setProfileImg] = useState("");
  const [name, setName] = useState(userDetails.first_name);
  const [dob, setDob] = useState(
    split_simple_year_date_month_from_str(userDetails.dob)
  );

  const [gender, setGender] = useState(userDetails.gender);
  const [email, setEmail] = useState(userDetails.email);

  const [show_otp_modal, setShowOtpModal] = useState(false);
  const [state, setState] = useState([
    {
      label: userDetails.state,
      value: userDetails.state_id,
    },
  ]);

  // USE EFFECTS

  useEffect(() => {
    fetch_lists();
  }, []);

  useEffect(() => {
    validationsResFun();
  }, [name, dob, gender, email, state]);

  // FUNCTIONS

  const [filterHideShow, setfilterHideShow] = useState(false);

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  function validationsResFun() {
    setValidationsRes(
      ValidationsService({
        name,
        dob,
        gender,
        email,
        state,
      })
    );
  }

  async function fetch_lists() {
    setLoading(true);
    try {
      const states_res = await get_states();
      if (states_res.status === 1) {
        const modified_states_list = states_res.data.map((item) => {
          return { label: item.title, value: item._id };
        });
        setStatesList(modified_states_list);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch lists function = ", err);
    }
  }

  const select_profile_img = async (files) => {
    try {
      if (files.length > 0) {
        const file = files[0];
        const imageTypeRegex = /image\/(jpg|jpeg|png|heic)/gm;
        const isMatch = file.type.match(imageTypeRegex);
        if (isMatch) {
          if (file.type === "image/heic" || file.name.endsWith(".heic")) {
            try {
              const blob = await heic2any({
                blob: file,
                toType: "image/jpeg",
              });
              const convertedFile = new File(
                [blob],
                file.name.replace(".heic", ".jpg"),
                { type: "image/jpeg" }
              );
              setImgPreview(URL.createObjectURL(convertedFile));
              setProfileImg(convertedFile);
            } catch (error) {
              toast(
                "Failed to process HEIC image. Please upload a JPG or PNG instead.",
                {
                  position: "top-center",
                  hideProgressBar: true,
                  type: "error",
                }
              );
              return;
            }
          } else {
            setImgPreview(URL.createObjectURL(file));
            setProfileImg(file);
          }
        } else {
          toast("Please select a file in JPG, PNG, HEIC, or JPEG format.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      }
    } catch (err) {
      consoleService("error in select profile image =", err);
    }
  };

  const handle_submit = async () => {
    if (!(calculateAge(dob) >= 12))
      return toast("You must be above 12 years of age to register.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
    setSubmit(true);
    if (
      !validationsRes.nameErr &&
      !validationsRes.dobErr &&
      !validationsRes.emailErr &&
      !validationsRes.stateErr
    ) {
      const phone = userDetails.phone;
      if (phone && phone.toString().trim()) {
        setShowOtpModal(true);
      } else {
        submitFun(null);
      }
    } else {
      toast("Some fields are missing.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
    }
  };

  const submitFun = async (otp, setOtpLoading) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("first_name", name);
      formData.append("dob", dob);
      formData.append("otp", otp);
      formData.append("email", email);
      formData.append("gender", gender);
      formData.append("state", state[0].value);
      profile_img && formData.append("profile_img", profile_img);
      formData.append("terms", true);
      const res = await update_patient_profile(formData);
      if (res.status === 1) {
        await set_patient_user_details();
        setShowOtpModal(false);
        setLoading(false);
        if (setOtpLoading != undefined) {
          setOtpLoading(false);
        }
        setSubmit(false);
        setModalShow(true);
      } else {
        setShowOtpModal(false);
        if (setOtpLoading != undefined) {
          setOtpLoading(false);
        }
        setLoading(false);
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in submit function = ", err);
    }
  };

  // NESTED COMPONENTS

  function Date_model(props) {
    const [selectedDate, setSelectedDate] = useState(
      dob
        ? new Date(
            localDateFromString(split_simple_year_date_month_from_str(dob))
          )
        : new Date(1940, 0, 1)
    );
    return (
      <Modal
        {...props}
        size="md"
        className="modalregs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setSelectedDate(new Date(dob));
          setShowDateModel(false);
        }}
      >
        <Modal.Body className="text-left">
          <section className="pb-4 pt-2 packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Select Date</h2>
                  <Calendar
                    onChange={(date) => {
                      setSelectedDate(new Date(date));
                    }}
                    value={selectedDate}
                    minDate={new Date(1940, 0, 1)}
                    maxDate={new Date()}
                    tileClassName="calendar_tiles"
                  />
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={(e) => {
              e.preventDefault();
              setDob(formatYMD(selectedDate));

              setShowDateModel(false);
            }}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Image src={SuccessIcon} alt="" />
          <h4>Success</h4>
          <p>Your account has been updated successfully!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setModalShow(false);
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const DeleteAccountConfirmationModal = (props) => {
    const deleteAccount = async () => {
      try {
        setShowDelConfirmationModal(false);
        setLoading(true);
        const res = await deactivate_account();
        if (res.status === 1) {
          setLoading(false);
          logOut();
        }
      } catch (err) {
        consoleService("error in delete Account function = ", err);
      }
    };

    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess modalBtn"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <h4>Are you Sure?</h4>
          <p className="mb-1">
            To delete your account.You can reactivate your account if you log in
            within 7 days. After seven days, your account will be permanently
            deleted.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={() => {
              setShowDelConfirmationModal(false);
            }}
          >
            No
          </Button>
          <Button
            // as={Link}
            onClick={() => {
              deleteAccount();
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  // MAIN RETURN

  return (
    <>
      <div className="breadHidePhone">
        <BannerSection banner={Banner} name={"Home"} title={"Edit Profile"} />
      </div>
      <section className="py-5 useraccount bg-light_dash">
        <div className="container">
          <div className="row">
            <div
              className={`col-xl-3 col-md-4 ${
                filterHideShow ? "leftShow" : "leftHide"
              }`}
            >
              <TherapistSidebar />
            </div>
            <div className="col-xl-9 col-md-8 fulltabBox">
              <div className="filterBox">
                <Link className="filterIcon" onClick={sideBarHide}>
                  <FaAlignLeft />
                </Link>
              </div>
              <div className="dashboard-widg-bar d-block">
                <div className="dashboard_body">
                  <h4 className="mb-4 ft-medium">Edit Profile</h4>
                  <Form>
                    <div
                      className="loginBox loginUpdateBox"
                      style={{ overflow: "inherit" }}
                    >
                      <div className="userImg">
                        <Image
                          src={imgPreview ? imgPreview : PlaceholderImg}
                          className="userImage"
                          alt=""
                        />
                        <div>
                          <Image src={EditIcon} className="editIcon" alt="" />
                          <input
                            type="file"
                            accept="image/jpg, image/jpeg, image/png, image/heic"
                            className="edit_img"
                            multiple={false}
                            onChange={(e) => {
                              select_profile_img(e.target.files);
                            }}
                          />
                        </div>
                      </div>
                      <Form.Control
                        type="text"
                        placeholder="Your Name"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      {submit && validationsRes.nameErr && (
                        <span className="validations_err" style={errorStyle}>
                          {validationsRes.nameErr}
                        </span>
                      )}

                      <Form.Control
                        className="mb-3"
                        type="text"
                        placeholder="D.O.B."
                        value={dob && get_simple_year_date_month_str(dob)}
                        onClick={() => {
                          setShowDateModel(true);
                        }}
                      />
                      {!submit && !validationsRes.dobErr && (
                        <small>
                          You must be above 12 years of age to register
                        </small>
                      )}
                      {submit && validationsRes.dobErr && (
                        <span className="validations_err" style={errorStyle}>
                          {validationsRes.dobErr}
                        </span>
                      )}
                      <Form.Control
                        type="text"
                        placeholder="Email Address"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      {submit && validationsRes.emailErr && (
                        <span className="validations_err" style={errorStyle}>
                          {validationsRes.emailErr}
                        </span>
                      )}
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Select
                          options={statesList}
                          values={state}
                          onChange={(value) => {
                            setState(value);
                          }}
                        />
                      </Form.Group>
                      {submit && validationsRes.stateErr && (
                        <span className="validations_err" style={errorStyle}>
                          {validationsRes.stateErr}
                        </span>
                      )}

                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput3"
                      >
                        <Form.Label>What is your gender?</Form.Label>
                        {["radio"].map((type) => (
                          <div key={`default-${type}`} className="boxFlex">
                            <Form.Check // prettier-ignore
                              type={type}
                              id="g1"
                              label="Male"
                              name="gender"
                              checked={gender == "Male"}
                              onClick={() => {
                                setGender("Male");
                              }}
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="g2"
                              label="Female"
                              name="gender"
                              checked={gender == "Female"}
                              onClick={() => {
                                setGender("Female");
                              }}
                            />
                            <Form.Check // prettier-ignore
                              type={type}
                              id="g3"
                              label="Unspecified"
                              name="gender"
                              checked={gender == "Unspecified"}
                              onClick={() => {
                                setGender("Unspecified");
                              }}
                            />
                          </div>
                        ))}
                      </Form.Group>

                      <Button
                        onClick={() => handle_submit()}
                        className="btn btn-primary me-3"
                      >
                        Submit
                      </Button>
                      <Button
                        onClick={() => setShowDelConfirmationModal(true)}
                        className="btn btn-primary me-3"
                      >
                        Delete Account
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>

              <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
              />
            </div>
          </div>
        </div>
        <Date_model show={showDateModel} />
        <DeleteAccountConfirmationModal show={showDelConfirmationModal} />
        {show_otp_modal && (
          <Otp_model
            show={true}
            onHide={() => {
              setShowOtpModal(false);
            }}
            verify_type="update_profile"
            handle_profile_update={submitFun}
          />
        )}
      </section>
    </>
  );
};

export default PatientRegistrationAndEditProfile;
